import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button, Dialog, Flex } from '@/components/common';
import { useCurrentUser } from '@/contexts';
import { useBlocks } from '@/hooks';

interface SafetyDialogProps {
  uid: string;
  name: string;
}

export function SafetyDialog({ uid, name }: SafetyDialogProps) {
  const { t } = useTranslation('profile');
  const navigate = useNavigate();
  const { user: authUser } = useCurrentUser();
  const { blockUser } = useBlocks(authUser);

  const handleBlock = async () => {
    try {
      await blockUser(uid);
      navigate(-1);
    } catch (err) {
      console.error('Block relationship failure:', err);
    }
  };

  const handleReport = () => {
    navigate(`/profile/${uid}/report`);
  };

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <Button
          type="button"
          variant="outline"
          color="crimson"
          radius="full"
          size="sm"
          fullWidth={false}
          data-testid="safety-trigger"
        >
          {t('view.actions.reportBlock')}
        </Button>
      </Dialog.Trigger>
      <Dialog.Content size="1">
        <Dialog.Title> {t('view.actions.reportBlock')}</Dialog.Title>
        <Flex direction="column" gap="3" py="2" px="2">
          <Dialog.Description size="1" color="gray" mb="0">
            {t('view.safetySubtitle', { name })}
          </Dialog.Description>
          <Flex direction="column" gap="2" mt="1" width="100%">
            <Dialog.Close>
              <Button
                type="button"
                variant="outline"
                color="gray"
                fullWidth
                onClick={() => {
                  handleBlock();
                }}
                data-testid="safety-block"
              >
                {t('view.actions.blockNamed', { name })}
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button
                type="button"
                variant="outline"
                color="crimson"
                fullWidth
                onClick={() => {
                  handleReport();
                }}
                data-testid="safety-report"
              >
                {t('view.actions.reportNamed', { name })}
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button type="button" variant="outline" color="gray" fullWidth>
                {t('view.actions.cancel')}
              </Button>
            </Dialog.Close>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export type { SafetyDialogProps };
